export default "__VITE_ASSET__C8UyWq7x__"